import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface TutorialSkipConfirmationContentProps {
    title: React.ReactNode;
    description: React.ReactNode;
    additionalDescription?: React.ReactNode;
    onContinueTutorial: () => void;
    onSkipTutorial: () => void;
}

const TutorialSkipConfirmationContent: React.FC<TutorialSkipConfirmationContentProps> = ({
    title,
    description,
    additionalDescription,
    onContinueTutorial,
    onSkipTutorial,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="border-bottom border-secondary border-2 pb-3">
                <Row>
                    <Col xs={1} className="p-0">
                        <Button variant="link" className="pt-0" onClick={onContinueTutorial}>
                            <i className="bi bi-arrow-left text-dark"></i>
                        </Button>
                    </Col>
                    <Col xs={11}>
                        <h4 className="fs-16 fw-bold text-dark mb-2">{title}</h4>
                        <p className="fs-7 text-dark mb-2">{description}</p>
                        {additionalDescription && <p className="fs-7 text-dark mb-0">{additionalDescription}</p>}
                    </Col>
                </Row>
            </div>

            <div className="d-grid gap-3 mt-3">
                <Button onClick={onContinueTutorial} className="w-100">
                    {t("Continue training")}
                </Button>
                <Button variant="link" className="w-100 py-0" onClick={onSkipTutorial}>
                    {t("Skip training")}
                </Button>
            </div>
        </>
    );
};

export default TutorialSkipConfirmationContent;
